<template>
  <button v-if="showBackButton || forceShow" @click="router.back()" class="btn btn-link text-dark ms-2 fs-1 pb-0">
    <i class="fas fa-arrow-left"> </i>
  </button>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const route = useRoute()
const router = useRouter()

const { forceShow = false } = defineProps<{ forceShow?: boolean }>()

const showBackButton = computed(() => {
  const paths = route.path.split('/')
  if (!paths.length) { return false }
  return paths.filter(p => p != '').length > 1
})
</script>